import { render } from "./Error404.vue?vue&type=template&id=6d7d7b7c"
import script from "./Error404.vue?vue&type=script&lang=ts"
export * from "./Error404.vue?vue&type=script&lang=ts"
script.render = render

export default script